
<script>
    import { selectedRadios, selectedChecks, selectedSwitches } from '../store'
    import Button from './Button.svelte';
    export let buttonOnly = false;
    export let title = '';
    let isMobile = false;
    let isActive = false;

    $: mobClass = isMobile ? 'mobile' : 'desktop'
    $: activeClass = isActive ? 'active' : ''
    $: console.log(isActive);

    function checkWindowWidth() {
        if (window.innerWidth <= 900) {
            isMobile = true;
        } else {
            isMobile = false;
        }
    }

    function objLength(obj) {
        return Object.entries(obj).length
    }

    function toggleMenu() {
        isActive = !isActive;
        if(isActive) {
            this.classList.add('is-active')
        } else {
            this.classList.remove('is-active')
        }
    }

    // call the function on component mount
    checkWindowWidth();

    // add event listener for window resize
    window.addEventListener('resize', checkWindowWidth);

  </script>

  {#if isMobile} 
    <div on:click={toggleMenu} class="mobile-sidebar {activeClass}">
        <span>
            <h3>Samenstelling</h3>
            <svg xmlns="http://www.w3.org/2000/svg" width="19.501" height="10.75" viewBox="0 0 19.501 10.75">
                <path id="Path_247" data-name="Path 247" d="M2548.252,738.15l8.336,8.336-8.336,8.337" transform="translate(-736.736 2557.588) rotate(-90)" fill="none" stroke="#ca1e22" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </svg>
        </span>
    </div>
  {/if}
<div class="sidebar-wrapper {mobClass} {activeClass}">
<div class="mobox-sidebar">
<h2>Jouw samenstelling</h2>
<div class="overview">
<div class="sidebar-entry">
    <span class="entry-title">Kamers</span>
    <div class="entry">
        {#if objLength($selectedChecks)}
        {#each Object.entries($selectedChecks) as [key, val]}
        <div>
            {val.id}
            {#if parseInt(val.aantal) > 1} 
            <span>{val.aantal}X</span>
            {/if}
        </div>
        {/each}
        {:else}
            <span>Nog geen kamer(s) gekozen...</span>
        {/if}
    </div>
</div>
<div class="sidebar-entry">
    <span class="entry-title">Wat ga je doen?</span>
    <div class="entry">
        {#if $selectedRadios.type}
        {$selectedRadios.type}
        {:else}
        <span>Nog niet gekozen...</span>
        {/if}
        </div>
    </div>
<div class="sidebar-entry no-border">
    <span class="entry-title">Opslagperiode</span>
    <div class="entry">
            {#if $selectedRadios.period}
            {$selectedRadios.period}
            {:else} 
            <span>Nog niet gekozen...</span>
            {/if}
            {#if $selectedRadios.preference}
            <span class="lowercase">
                {$selectedRadios.preference}
            </span>
            {/if}
            {#if $selectedRadios.service}
            <div>{$selectedRadios.service}</div>
            {:else} 
            <span>Nog niet gekozen...</span>
            {/if}

            <span class="entry-title-extra">Extra's</span>
            <div class="entry-extra">
                {#if Object.entries($selectedSwitches).length}
                    {#each Object.entries($selectedSwitches) as [key, val]}
                    <div>
                        {val.id}
                    </div>
                    {/each}
                {:else} 
                <span>Geen extra's gekozen</span>
                {/if}
                </div>

        </div>
    </div>
    </div>
    <Button text="Dit wordt 'm, volgende stap" type="submit"></Button>
</div>
</div>
<style>
    h2 {
        font-weight: 700;
        color: rgba(0,63,49,1);
        margin-bottom: 1rem;
    }
    .sidebar-wrapper {
        position: relative;
        padding: 50px;
        background: #E5EBEA;
        height: 100%;
    }
    .sidebar-wrapper.mobile {
        position: fixed;
        width: calc(100% - 10px);
        height: fit-content;
        padding: 25px 15px;
        left: 5px;
        bottom: 70px;
        background: #E5EBEA;
        border-radius: 5px;
        z-index: 8;
        box-shadow: 0px 0px 16px rgba(0,63,49,.1);
        transform: translateY(120%);
        transition: all .3s cubic-bezier(0.165, 0.84, 0.44, 1)
    }
    .sidebar-wrapper.mobile.active {
        transform: translateY(0);

    }
    .mobox-sidebar {
        position: sticky;
        top: 50px;
    }
    .mobile-sidebar {
        position: fixed;
        bottom: 5px;
        left: 5px;
        padding: 20px;
        background: #fff;
        z-index: 9;
        width: fit-content;
        color: white;
        border-radius: 5px;
        box-shadow: 0px 0px 16px rgba(0,63,49,.1);
    }
    .button-mobile {
        position: fixed;
        bottom: 5px;
        right: 5px;
        z-index: 9;
        padding: 5px;
        background: #CA1E22;
    }
    .mobile-sidebar h3 {
        color: #003F31;
        padding: 0;
        font-size: 18px;
        text-align: center;
    }
    .mobile-sidebar svg {
        transition: all .3s ease;
        fill: white;
    }

    .mobile-sidebar.active svg {
        rotate: 180deg;
    }

    .mobile-sidebar span {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        gap: 20px;
    }

    .overview {
        background: white;
        padding: 30px;

    }
    .sidebar-entry {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #D9E2E0;
    }
    .sidebar-entry.no-border {
        border-bottom: 0;
        margin-bottom: 0;
        padding-bottom: 0;
    }
    .entry-title {
        font-weight: 700;
        color: #003F31;
        font-size: 16px;
    }
    .entry {
        display: flex;
        flex-direction: column;
        text-align: right;
    }
    .entry-title-extra {
        margin-top: 10px;
        font-style: italic;
        display: block;
    }
    .lowercase {
        text-transform: lowercase;
    }
    .toggle-button {
        appearance: unset;
        all: unset;
        font-size: 18px;
        font-weight: 700;
        background: #CA1E22;
        color: white;
        padding: 10px 25px;
        display: flex;
        width: 100%;
        position: relative;
        box-sizing: border-box;
        border-radius: 5px;
        margin-top: 15px;
    }
</style>